/** Cài đặt âm thanh quiz — localStorage + sự kiện đồng bộ tab/route */

export const LS_QUIZ_SFX = 'eduquiz_play_sfx_enabled';
export const LS_QUIZ_MUSIC = 'eduquiz_play_music_enabled';
export const LS_QUIZ_SFX_VOL = 'eduquiz_play_sfx_volume';
export const LS_QUIZ_MUSIC_VOL = 'eduquiz_play_music_volume';

/** Cho listener storage (đồng bộ tab khác) */
export const LS_QUIZ_AUDIO_KEYS = new Set([
  LS_QUIZ_SFX,
  LS_QUIZ_MUSIC,
  LS_QUIZ_SFX_VOL,
  LS_QUIZ_MUSIC_VOL,
]);

export const QUIZ_AUDIO_PREFS_EVENT = 'eduquiz-audio-prefs-changed';

function clamp(n, lo, hi) {
  return Math.min(hi, Math.max(lo, n));
}

export function readQuizAudioPrefs() {
  let sfxOn = true;
  /** Lần đầu vào web: bật nhạc nền mặc định (vẫn cần chạm màn hình trên trang quiz để trình duyệt cho phát). */
  let musicOn = true;
  let sfxVol = 72;
  let musicVol = 42;
  try {
    const s = localStorage.getItem(LS_QUIZ_SFX);
    if (s !== null) sfxOn = s === '1';
    const m = localStorage.getItem(LS_QUIZ_MUSIC);
    if (m !== null) musicOn = m === '1';
    const sv = parseInt(localStorage.getItem(LS_QUIZ_SFX_VOL) || '', 10);
    if (Number.isFinite(sv)) sfxVol = clamp(sv, 0, 100);
    const mv = parseInt(localStorage.getItem(LS_QUIZ_MUSIC_VOL) || '', 10);
    if (Number.isFinite(mv)) musicVol = clamp(mv, 0, 100);
  } catch {
    /* ignore */
  }
  return { sfxOn, musicOn, sfxVol, musicVol };
}

export function writeQuizAudioPrefs(partial) {
  try {
    if (partial.sfxOn !== undefined) localStorage.setItem(LS_QUIZ_SFX, partial.sfxOn ? '1' : '0');
    if (partial.musicOn !== undefined) localStorage.setItem(LS_QUIZ_MUSIC, partial.musicOn ? '1' : '0');
    if (partial.sfxVol !== undefined) {
      localStorage.setItem(LS_QUIZ_SFX_VOL, String(clamp(Math.round(partial.sfxVol), 0, 100)));
    }
    if (partial.musicVol !== undefined) {
      localStorage.setItem(LS_QUIZ_MUSIC_VOL, String(clamp(Math.round(partial.musicVol), 0, 100)));
    }
  } catch {
    /* ignore */
  }
  try {
    window.dispatchEvent(new CustomEvent(QUIZ_AUDIO_PREFS_EVENT, { detail: readQuizAudioPrefs() }));
  } catch {
    /* ignore */
  }
}
